import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useLocation, useNavigate } from 'react-router-dom';
import { Typography } from '@mui/material';
// import AssetVideoPlayer from 'portal/common/asset/AssetVideoPlayer';
import { useStore, } from '@mcn-platform/models';
import PlaceHolder from '../common/PlaceHolder';
import { configMeetingPage } from '../common/portalConfig';
import { getMeetingData } from '../item/getData';
import MeetingSummary from './MeetingSummary';
const MeetingSummaryWidget = ({ meetingKey, settings, editData, }) => {
    const store = useStore();
    const { getOrLoad, getMeetingRegistration } = store;
    const [meetingRegistration, setMeetingRegistration,] = useState();
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const location = useLocation();
    const meeting = getOrLoad('meeting', meetingKey);
    const isPortalApp = !editData;
    useEffect(() => {
        const loadData = async () => {
            try {
                const registration = await getMeetingRegistration(meetingKey);
                setMeetingRegistration(registration);
            }
            catch (err) {
                const isRegistrationError = err?.errors?.some((e) => e?.message?.includes('Registration not found'));
                if (isRegistrationError) {
                    setMeetingRegistration(undefined);
                    setError(null); // No error message, as this is a valid case
                }
                else {
                    console.error('Error fetching meeting registration', err);
                    setError('An error occurred while fetching registration.');
                }
            }
        };
        loadData();
    }, [getMeetingRegistration, meetingKey]);
    if (!isPortalApp && !meetingKey) {
        return (_jsx(PlaceHolder, { placeHolderName: "Select meeting to see preview" }));
    }
    if (error) {
        return (_jsx("div", { style: { textAlign: 'center', marginTop: '2rem' }, children: _jsx(Typography, { variant: "body1", color: "error", children: error }) }));
    }
    const { buttonLabel, action, instructorAction, } = configMeetingPage(store, meeting, meetingRegistration, navigate, location, '.', isPortalApp);
    const observedAction = action ? async () => {
        try {
            const registration = await action() || undefined;
            if (registration?.Registration) {
                setMeetingRegistration(registration.Registration);
            }
            else {
                const updatedRegistration = await getMeetingRegistration(meetingKey);
                setMeetingRegistration(updatedRegistration);
            }
            setError(null);
        }
        catch (err) {
            console.error('Error performing action', err);
            const errorMessage = err instanceof Error ? err.message : 'An error occurred during the action.';
            setError(errorMessage);
        }
    } : undefined;
    return (_jsx(MeetingSummary, { meeting: meeting, buttonLabel: buttonLabel, action: observedAction, instructorAction: instructorAction, settings: settings }));
};
MeetingSummaryWidget.getData = async ({ meetingKey }, store) => {
    console.log('Adding meeting to preload', meetingKey);
    if (!meetingKey) {
        console.log('No meeting to load for MeetingSummary card');
        return 'ok';
    }
    await getMeetingData(store, meetingKey);
    // console.log('imageAsset', imageAsset);
    return 'ok';
};
MeetingSummaryWidget.defaultProps = {
    settings: {
        showVideo: true,
        showInfo: true,
        showHeadline: true,
        showDescription: true,
        showOfferedBy: true,
        showInstructor: true,
        showEnrollButton: true,
        showActionButton: true,
    },
    editData: undefined,
};
MeetingSummaryWidget.meta = {
    group: 'design',
    name: 'Meeting Summary Card',
    description: 'Component displays the details of a meeting',
    props: [
        {
            key: 'meetingKey',
            name: 'Meeting',
            type: 'meeting', // note this is a special type recognized by the system
            description: 'The meeting to display information about',
        },
        {
            key: 'settings.showTitle',
            name: 'Show Title',
            type: 'boolean',
            description: 'Show title',
        },
        {
            key: 'settings.showVideo',
            name: 'Show Image or Video',
            type: 'boolean',
            description: 'Show the intro video on the card',
        },
        {
            key: 'settings.showInfo',
            name: 'Show Info Bar',
            type: 'boolean',
            description: 'Show the meeting info on the card',
        },
        {
            key: 'settings.showHeadline',
            name: 'Show Headline',
            type: 'boolean',
            description: 'Show the meeting headline on the card',
        },
        {
            key: 'settings.showDescription',
            name: 'Show Description',
            type: 'boolean',
            description: 'Show the meeting description on the card',
        },
        {
            key: 'settings.showInstructor',
            name: 'Show Instructor',
            type: 'boolean',
            description: 'Show the instructor field on the card',
        },
        {
            key: 'settings.showActionButton',
            name: 'Show Call to Action Button',
            type: 'boolean',
            description: 'Show the instructor field on the card',
        },
    ],
    defaultConfig: {
        type: 'component',
        component: 'MeetingSummary',
        props: {
            meetingKey: '@meetingKey',
            handleEnroll: '@enrollAction',
            settings: {
                showTitle: true,
                showVideo: true,
                showInfo: true,
                showHeadline: true,
                showInstructor: true,
                showActionButton: true,
                showDescription: true,
            },
        },
    },
};
export default observer(MeetingSummaryWidget);
//# sourceMappingURL=MeetingSummaryWidget.js.map